import React from 'react';
import { LeafyGreen } from 'lucide-react';
import { explainerSlugKey } from 'src/shared/constants/portfolio';
import { PortfolioData } from 'src/app/portfolio/state/api/portfolioQuery';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import useCustomer from 'src/app/customers/hooks/useCustomer';
import { SortOrder } from 'src/shared/types';
import { HabitatInsightsMetricType } from 'src/shared/types/graph/survey';
import PortfolioAreaChart from 'src/shared/components/chart-templates/portfolio-area-chart/PortfolioAreaReChart';
import PortfolioExploreButton from './PortfolioExploreButton';
import SummaryCard from './SummaryCard';

const VegetationHealthChart = ({ portfolioData }: { portfolioData: PortfolioData }) => {
    const vegetationHealth = portfolioData.summary.metrics.find(metric => metric.label === 'Vegetation Health');
    const navigate = useAppNavigation();
    const { currentCustomerId } = useCustomer();

    if (!vegetationHealth || !vegetationHealth.datum || !vegetationHealth.years) {
        return null;
    }

    const chartData = vegetationHealth.years?.map((year, index) => ({ year, value: vegetationHealth.datum?.[index] || 0 })) || [];

    const handleExploreClick = () => {
        navigate.toPortfolioSiteExplorer({
            customerId: currentCustomerId,
            selectedMetric: HabitatInsightsMetricType.PRIMARY_PRODUCTIVITY,
            sortDirection: SortOrder.ASC,
            view: 'list',
        });
    };

    return (
        <SummaryCard
            dataTestId='portfolio-vegetation-health-chart'
            containerClasses='gap-3 p-5'
            cardIcon={<LeafyGreen className='text-primary' />}
            cardTitle='Vegetation health'
            cardSubtitle='Assessment of plant vigor and density, crucial for ecosystem function.'
            titleExplainerSlug={{
                defaultSlug: explainerSlugKey.portfolioVegetationHealth,
                explainerSlug: `${explainerSlugKey.portfolioVegetationHealth}-te`,
            }}
            cardBody={<PortfolioAreaChart chartData={chartData} />}
            action={<PortfolioExploreButton sectionName='vegetation-health' onClick={handleExploreClick} />}
            frameworks={vegetationHealth.frameworks}
        />
    );
};

export default VegetationHealthChart;
